import { ScrollReveal } from "./ScrollReveal";
import { Home, Building2, Store, Landmark } from "lucide-react";
import { motion } from "framer-motion";

const categories = [
  {
    icon: Home,
    title: "Residential Rent",
    count: "1500+",
    color: "from-blue-500 to-indigo-600",
    rotate: -3,
    y: 0,
  },
  {
    icon: Building2,
    title: "Residential Sell",
    count: "12000+",
    color: "from-violet-500 to-purple-600",
    rotate: 2,
    y: -20,
  },
  {
    icon: Store,
    title: "Commercial Rent",
    count: "3,100+",
    color: "from-amber-500 to-orange-600",
    rotate: -2,
    y: 10,
  },
  {
    icon: Landmark,
    title: "Commercial Sell",
    count: "4,500+",
    color: "from-emerald-500 to-teal-600",
    rotate: 3,
    y: -10,
  },
];

const PropertyCategoriesSection = () => (
  <section className="section-light py-20 sm:py-28 overflow-hidden">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground text-center mb-3">
          Categories
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4 text-foreground">
          Deal in Any{" "}
          <span className="gradient-text font-bold">Property Category</span>
        </h2>
        <p className="text-center text-muted-foreground mb-16 max-w-lg mx-auto text-sm leading-relaxed">
          Whether it's a cozy apartment for rent or a commercial showroom for
          sale — PRObroker covers every property type across Ahmedabad.
        </p>
      </ScrollReveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 max-w-4xl mx-auto">
        {categories.map((cat, i) => (
          <ScrollReveal key={i} delay={i * 0.1}>
            <motion.div
              initial={{ rotate: cat.rotate, y: cat.y }}
              whileInView={{ rotate: 0, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                delay: i * 0.1,
                type: "spring",
                stiffness: 120,
              }}
              whileHover={{ y: -8, scale: 1.04, rotate: cat.rotate * 0.5 }}
              className="relative bg-background rounded-2xl border border-border p-6 sm:p-8 text-center cursor-pointer group hover:border-primary/20 hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              {/* Decorative corner accent */}
              <div
                className={`absolute -top-6 -right-6 w-20 h-20 rounded-full bg-gradient-to-br ${cat.color} opacity-10 group-hover:opacity-20 transition-opacity`}
              />

              <div
                className={`w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br ${cat.color} flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300`}
              >
                <cat.icon className="w-6 h-6 sm:w-7 sm:h-7 text-primary-foreground" />
              </div>

              <h3 className="text-sm sm:text-base font-semibold text-foreground mb-1">
                {cat.title}
              </h3>
              <p className="text-xs text-muted-foreground">
                {cat.count} properties
              </p>
            </motion.div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyCategoriesSection;
